import { FavoriteContact } from 'bpm/models/contact'
import { KNOWLEDGEPOINT_CDN_URL } from 'bpm/shared/utils/urlUtils'

export const FavoriteContactsResolver = {
    favoriteContacts: (): FavoriteContact[] => [
        {
            userId: 1,
            email: 'masonjasonblythe@acme.com',
            profileInfo: {
                firstName: 'Richard Mason Anthony Timothy',
                lastName: 'Blythe',
                professionalRole: 'Consultant',
                phone: '369-315-8742',
                imageUrl: `${KNOWLEDGEPOINT_CDN_URL}/mockedimages/masonblythe.png`,
            },
        },
        {
            userId: 2,
            email: 'ericajaninedanner@acme.com',
            profileInfo: {
                firstName: 'Erica',
                lastName: 'Danner',
                professionalRole: 'Manufacturer',
                phone: '923-527-4511',
                imageUrl: `${KNOWLEDGEPOINT_CDN_URL}/mockedimages/ericadanner.png`,
            },
        },
        {
            userId: 3,
            email: 'mattieemerson@acme.com',
            profileInfo: {
                firstName: 'Mattie',
                lastName: 'Emerson',
                professionalRole: 'Secretary',
            },
        },
        {
            userId: 4,
            email: 'tracysimon@acme.com',
            profileInfo: {
                firstName: 'Tracy',
                lastName: 'Simon',
                professionalRole: 'Other',
                phone: '268-909-0193',
            },
        },
        {
            userId: 5,
            email: 'carlbeeker@acme.com',
            profileInfo: {
                firstName: 'Carl',
                lastName: 'Beeker',
                professionalRole: 'Customer',
                imageUrl: `${KNOWLEDGEPOINT_CDN_URL}/mockedimages/carlbeeker.png`,
            },
        },
        {
            userId: 6,
            email: 'EricJohnJohnson@acme.com',
            profileInfo: {
                firstName: 'Eric',
                lastName: 'Johnson',
                professionalRole:
                    'Vice President of Product Manufacturing and Distribution',
                phone: '580-578-7628',
                imageUrl: `${KNOWLEDGEPOINT_CDN_URL}/mockedimages/ericjohnson.png`,
            },
        },
        {
            userId: 7,
            email: 'nathanielosborne@acme.com',
            profileInfo: {
                firstName: 'Nathaniel',
                lastName: 'Osborne',
                professionalRole: 'Custodian',
            },
        },
    ],
}
